import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["isDismissible"];
import * as React from 'react';
import { Message } from './message';
import { safeInvoke } from '../../../library';
export var UncontrolledMessage = function UncontrolledMessage(props) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isDismissed = _React$useState2[0],
    setIsDismissed = _React$useState2[1];
  var dismiss = function dismiss() {
    setIsDismissed(true);
    safeInvoke(props.onDismiss);
  };
  var isDismissible = props.isDismissible,
    passProps = _objectWithoutProperties(props, _excluded);
  return React.createElement(Message, _extends({}, passProps, {
    isDismissed: isDismissed,
    onDismiss: isDismissible ? dismiss : undefined
  }));
};
UncontrolledMessage.displayName = 'UncontrolledMessage';
UncontrolledMessage.defaultProps = {
  isDismissible: false
};